import PageSidebarMobile from './page-sidebar-mobile';

export default PageSidebarMobile;